<template>
  <div>
    <cbs-objects-tbl
      meta-filter="catalog"
      title="CATALOGS"
    />
  </div>
</template>

<script>
import CbsObjectsTbl from '@/cubus/components/objects/CbsObjectsTbl.vue'
import useCubus from '@/cubus/services/useCubus'

export default {
  name: 'CbsObjectCatalog',
  components: {
    CbsObjectsTbl,
  },
  created() {
    useCubus.setPageTitle('References')
  },
}
</script>

<style scoped>

</style>
